/**
 * LEP Packshot — interactive hotspot dots with popup cards
 *
 * Dots appear in sequence when section is ~50% visible (IntersectionObserver).
 * Desktop: hover on dot → show popup.
 * Mobile: tap on dot → show popup below packshot.
 */

(function () {
  'use strict';

  var SCENE_SELECTOR = '[data-lep-packshot]';
  var DOT_SELECTOR = '.lep-dot';
  var POPUP_SELECTOR = '.lep-popup';
  var MOBILE_POPUP_CONTAINER = '.lep-packshot-scene__mobile-popup';
  var REVEAL_DELAY = 700; // ms between each dot reveal
  var BREAKPOINT_LG = 1024;

  function init() {
    var scenes = document.querySelectorAll(SCENE_SELECTOR);
    if (!scenes.length) return;

    scenes.forEach(function (scene) {
      var dots = scene.querySelectorAll(DOT_SELECTOR);
      var popups = scene.querySelectorAll(POPUP_SELECTOR);
      var mobileContainer = scene.querySelector(MOBILE_POPUP_CONTAINER);
      var revealed = false;

      // ---- IntersectionObserver: reveal dots at 50% visibility ----
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !revealed) {
            revealed = true;
            revealDots(dots);
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(scene);

      // ---- Desktop: hover ----
      dots.forEach(function (dot) {
        var targetId = dot.getAttribute('data-popup');
        var popup = scene.querySelector('[data-popup-id="' + targetId + '"]');

        if (!popup) return;

        // Hover enter
        dot.addEventListener('mouseenter', function () {
          if (window.innerWidth < BREAKPOINT_LG) return;
          hideAllPopups(popups, dots);
          showPopup(popup, dot);
        });

        // Hover leave
        dot.addEventListener('mouseleave', function () {
          if (window.innerWidth < BREAKPOINT_LG) return;
          hidePopup(popup, dot);
        });

        // Click / Tap (mobile)
        dot.addEventListener('click', function () {
          if (window.innerWidth >= BREAKPOINT_LG) return;

          var isActive = dot.classList.contains('is-active');
          hideAllPopups(popups, dots);

          if (!isActive && mobileContainer) {
            // Move popup clone to mobile container
            showMobilePopup(popup, dot, mobileContainer);
          }
        });
      });
    });
  }

  function revealDots(dots) {
    dots.forEach(function (dot, index) {
      setTimeout(function () {
        dot.classList.add('is-visible');
      }, index * REVEAL_DELAY);
    });
  }

  function showPopup(popup, dot) {
    popup.classList.add('is-active');
    dot.classList.add('is-active');
  }

  function hidePopup(popup, dot) {
    popup.classList.remove('is-active');
    dot.classList.remove('is-active');
  }

  function hideAllPopups(popups, dots) {
    popups.forEach(function (p) { p.classList.remove('is-active'); });
    dots.forEach(function (d) { d.classList.remove('is-active'); });
  }

  function showMobilePopup(popup, dot, container) {
    // On mobile, we clone and show the popup in the mobile container
    container.innerHTML = '';
    var clone = popup.cloneNode(true);
    clone.classList.add('is-active');
    container.appendChild(clone);
    dot.classList.add('is-active');

    // Scroll to reveal
    setTimeout(function () {
      container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
